import {
  RazorBadgeTwo,
  RazorDateTime,
  RazorModal,
} from "../../../../../../components/razor-reuse";
import { myComponentProps } from "../../../../settings/account/modals/EndSessionModal";
import { ALL_ICONS } from "../../../../../../assets/icons/AllIcons";
import { downloadImageSrc, formatBytes } from "../../../../../../utils/Helper";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RootState from "../../../../../../redux/type";
import { systemRoles } from "../../../../../../utils/roles";

interface DocModalProp extends myComponentProps {
  url: string;
  doc_name: string;
  file_name: string;
  file_size: number;
  status: string;
  date: string;
}

export default function DocumentModal({
  visible,
  onClose,
  url,
  doc_name,
  file_name,
  file_size,
  status,
  date,
}: DocModalProp) {
  const [scale, setScale] = useState(1);
  const [imageError, setImageError] = useState(false);

  const zoomIn = () => setScale((prev) => Math.min(prev + 0.2, 3)); // Max scale 3x
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.2, 0.5)); // Min scale 0.5x

  const { user } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (!visible) {
      setScale(1);
      setImageError(false);
    }
  }, [visible]);

  return (
    <RazorModal
      visible={visible}
      onClose={onClose}
      onBtnClick={() => {}}
      className="doc-modal"
      dontShowClose
    >
      <>
        {/* <section className="bg-white flex flex-col size-full overflow-y-auto"> */}
        <div className="py-[10px] px-[24px] h-fit flex justify-between items-center">
          <p className="text-[12px] text-gray-02">
            {doc_name || file_name || "---"}
          </p>
          <figure
            onClick={onClose}
            className="size-fit cursor-pointer hover:scale-[1.15] transition-all ease-linear"
          >
            {ALL_ICONS.close_modal}
          </figure>
        </div>
        <div className="flex flex-1 overflow-hidden select-none">
          <div className="h-full w-[55%] flex flex-col max-h-full">
            <div className="bg-gray-03 size-full p-[30px] relative flex justify-center items-center overflow-hidden">
              {user?.permissions?.includes(systemRoles[10]) && !imageError && (
                <figure
                  onClick={() => {
                    downloadImageSrc(url, doc_name || file_name);
                  }}
                  className="size-fit p-[4px] cursor-pointer absolute top-[5px] right-[5px] scale-90 hover:scale-95 transition-all ease-linear"
                >
                  {ALL_ICONS.download_icon}
                </figure>
              )}
              <div className="w-full h-full">
                {imageError ? (
                  <div className="size-full place-content-center grid">
                    <span className="text-gray-01 text-[14px]">
                      Image not available
                    </span>
                  </div>
                ) : (
                  <img
                    src={url}
                    className="size-full object-contain"
                    alt="uploaded document"
                    style={{
                      transform: `scale(${scale})`,
                      transition: "transform 0.3s ease-in-out",
                    }}
                    // onError={() => setImageError(true)}
                  />
                )}
              </div>
            </div>
            <section className="bg-white px-[29px] py-[11px] flex gap-x-[15px] border-r-[2px] border-gray-03 w-full">
              <figure
                onClick={zoomIn}
                className="cursor-pointer hover:scale-[1.25] transition-all ease-linear"
              >
                {ALL_ICONS.zoomin_icon}
              </figure>
              <figure
                onClick={zoomOut}
                className="cursor-pointer hover:scale-[1.25] transition-all ease-linear"
              >
                {ALL_ICONS.zoomout_icon}
              </figure>
            </section>
          </div>
          <div className="py-[30px] px-[40px] space-y-[12px]">
            <div className="flex items-center gap-x-[17px]">
              <p className="text-[12px] text-grap-02">File name:</p>
              <p className="text-primary text-[12px] bg-[#724DE41A] px-[8px] rounded-[6px]">
                {file_name}
              </p>
            </div>
            <div className="flex items-center gap-x-[17px]">
              <p className="text-[12px] text-grap-02">File Size:</p>
              <p className="text-gray-01 text-[14px]">
                {formatBytes(file_size)}
              </p>
            </div>
            <div className="flex items-center gap-x-[17px]">
              <p className="text-[12px] text-grap-02">Status:</p>
              <RazorBadgeTwo
                className={`text-[14px] ml-[8px] !py-[4px] !px-[12px]
                     ${
                       status === "GREEN"
                         ? "success"
                         : status === "RED"
                           ? "failed"
                           : "pending"
                     }`}
                text={
                  status === "GREEN"
                    ? "approved"
                    : status === "RED"
                      ? "rejected"
                      : status?.replaceAll("-", " ")
                }
              />
            </div>
            <div className="flex items-center gap-x-[17px]">
              <p className="text-[12px] text-grap-02">Date:</p>
              <p className="text-gray-01 text-[14px]">
                <RazorDateTime
                  date={date}
                  hideAgo
                  className="[&_span]:!text-[14px] [&_span]:ml-[4px] [&_span]:!text-gray-01"
                />
              </p>
            </div>
          </div>
        </div>
        {/* </section> */}
      </>
    </RazorModal>
  );
}
